/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const MASQUERADER_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "DashboardVerifierAnalysis"],
  ["read", "UserList"],
  ["read", "HoldersGroups"],
  ["read", "HoldersGroups.Holders"],
  ["read", "Holders"],
  ["read", "Credential"],
  ["read", "HoldersBatchImport"],
  ["read", "IssuedCredentialList"],
  ["read", "CredentialList"],
  ["read", "IssueNewCredential"],
  ["read", "IssuedNetworkGraph"],
  ["read", "Placeholder"],
  ["read", "OrgProfile"],
  ["read", "PaymentFailedFAC"],
  ["read", "OpenRegistrationCostumePage"],
  ["read", "Costume"],
  ["read", "CostumeOpenReg"],
  ["read", "PurchasedCostume"],
  ["read", "PurchasedCostumeList"],
  ["read", "PurchasedCostumeDetails"],
  ["read", "AboutMe"],
  ["read", "ProfileUpdateStepper"],
  ["read", "ChangeCostumeOptions"],
  ["read", "APV2PaymentDetails"],
];

export const MASQUERADER_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
